module.exports = __webpack_public_path__ + "static/media/city-door-elements-2-svgrepo-com.c8a64df5.svg";